// @flow
import { combineReducers } from 'redux';
import all from './all';
import details from './details';

export default combineReducers({
  all,
  details,
});
